import React from 'react';

const SliderHome = () => {
  return <div className="w-full">
        <img src="assets/carousel_1.jpg" alt="Carousel 1" className="w-full" />
    </div>;
};

export default SliderHome;
